import API_BASE_URL from '../Config';

const AUDIT_API = `${API_BASE_URL}/audit/login`;

/**
 * Obtiene una lista paginada de auditoría de login con filtros.
 */
export const getLoginAuditoria = async (filters = {}, page = 0, size = 10) => {
    const { usuarioId, sucursalId, desde, hasta } = filters;
    let url = `${AUDIT_API}?page=${page}&size=${size}&sort=fechaAcceso,desc`;
    
    if (usuarioId) url += `&usuarioId=${usuarioId}`;
    if (sucursalId) url += `&sucursalId=${sucursalId}`;
    if (desde) url += `&desde=${desde}`;
    if (hasta) url += `&hasta=${hasta}`;

    const response = await fetch(url, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    
    if (!response.ok) throw new Error(`Error ${response.status}: Error al obtener auditoría`);
    return await response.json();
};

/**
 * Registra el logout en el backend.
 */
export const registrarLogout = async () => {
    const response = await fetch(`${API_BASE_URL}/logout`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    return response.ok;
};
